import { useSearchParams } from 'react-router-dom';
import { isTranslationKey, useI18n } from '../i18n';
import { Card } from '../components/ui';

export function LoginPage() {
  const { t, locale, setLocale } = useI18n();
  const [params] = useSearchParams();
  const failure = params.get('login_error');

  // Le code d'échec vient de la redirection OAuth : on le traduit s'il est connu,
  // sinon on reste générique plutôt que d'afficher une chaîne technique.
  const failureKey = failure ? `error.${failure}` : null;
  const failureMessage =
    failureKey && isTranslationKey(failureKey) ? t(failureKey) : failure ? t('login.failed') : null;

  return (
    <div className="login">
      <Card title={t('login.title')}>
        {failureMessage ? (
          <div className="banner banner-error" role="alert">
            {failureMessage}
          </div>
        ) : null}
        <p>{t('login.intro')}</p>
        <p>
          <a className="btn btn-primary" href="/api/v1/auth/discord">
            {t('login.button')}
          </a>
        </p>
        <p>
          <button
            className="btn btn-ghost"
            onClick={() => setLocale(locale === 'fr' ? 'en' : 'fr')}
          >
            {t('nav.language')}
          </button>
        </p>
      </Card>
    </div>
  );
}
